import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, Col,Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import moment from "moment";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx"
import { saveAs } from "file-saver";


import { useLocation } from "react-router-dom"; // si usas react-router
import QRScanner from "../../componentes/QRScanner";

const modeloDatos = {
    registroID:0,
      empresaID: 1,
       comercio: ''
    , rnc: "",
    mes: 0,
    ano:0
    , ncf: ""
    , fechaFactura: new Date,
     fecha: new Date,
     montoItbs: ""
    , montoTotal: ""
    , comentario: "",
    formaPago:"",
      creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const Seleccion = {
    mes: new Date().getMonth() + 1,
    ano: new Date().getFullYear()
}

const R_F_NCF = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Visualizar, setVisualizar] = useState(false);
    const [Impresion, setImpresion] = useState(false);
    const [Select, setSelect] = useState(Seleccion);
    const [R_API, setR_API] = useState("")

    

    const handleChange = (e) => {
      //  let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;

        if (e.target.name == "rnc" && e.target.value.length > 8) {
            ValidarRNC(e.target.value,0,0,0);
              
        }

        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }


    const ValidarRNC = async (x, ncf, fechafactura, montoTotal) => {
       let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, comercio: (data1).descripcion, rnc: x, ncf:ncf, fechaFactura:fechafactura, montoTotal:montoTotal
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x,ncf:""
                })
}           
        }
    }
    const handleQrResult = (text) => {
        // 'text' debería ser una URL, por ejemplo:
        // https://ecf.dgii.gov.do/ecf/ConsultaTimbre?RncEmisor=101602465&RncComprador=133254239&...
        try {
            const url = new URL(text);
            const params = new URL(url).searchParams;
            const rnc = params.get("RncEmisor"); // "133254239"
            const ncf = params.get("ENCF"); // "133254239"
            const fechaFactura1 =params.get("FechaEmision"); // "133254239"
            const montoTotal = params.get("MontoTotal"); // "133254239"
            const limpio = fechaFactura1.trim().replace(/^'(.*)'$/, "$1"); // -> 21-08-2025

            const fechaFactura = moment(limpio, "DD-MM-YYYY", true).format("YYYY-MM-DD");
            ValidarRNC(rnc, ncf, fechaFactura , montoTotal)
            // ponerlo en tu formulario:
            setTabla((t) => ({ ...t, rnc, ncf, fechaFactura, montoTotal }));
        } catch (e) {
            // si el QR no es una URL válida, puedes manejarlo aquí
            console.warn("QR no es una URL válida:", text);
        }
    };

    const nuevo = () =>{
        setVerModal(!verModal);
        setTabla(modeloDatos);
        // === Tu código tal cual ===
   
      
    }

    const handleChange1 = (e) => {
        setSelect({
            ...Select,
            [e.target.name]: e.target.value
        })       
    }

    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "DGII/ListaRegistroFacturaNCF" + "/" + correo + "/" + Select.mes + "/" + Select.ano);
        if (response.ok) {
            let data = await response.json()
            SetListado(data);
            setPendiente(false);
            setR_API(Api + "DGII/ListaRegistroFacturaNCF" + "/" + correo + "/" + Select.mes + "/" + Select.ano)

        }
    }

    useEffect(() => {
        obtenerDatos();
    }, [Select])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        
        tabla.ano = new Date( tabla.fechaFactura).getFullYear();
            tabla.mes = new Date(tabla.fechaFactura).getMonth() + 1;
        tabla.fechaFactura = new Date(tabla.fechaFactura);
        if (tabla.registroID == 0) {          
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/GuardarRegistroFacturaNCF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/EditarRegistroFacturaNCF", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            obtenerDatos();

            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
               
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                //await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
            obtenerDatos()
        } else {
            alert("error al guardar")
        }
        setPendiente(true)
        obtenerDatos()
    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            //obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        
        var list = Listado.map(x => ({
            RNC: x.rnc, Comercio: x.comercio, NCF: x.ncf, Fecha: moment(x.fechaFactura).format("DD/MM/YYYY"),
            MontoITBS:x.montoItbs,MontoTotal: x.montoTotal, FormaPago:x.formaPago ,Comentario:x.comentario
        }));
        var ws = XLSX.utils.json_to_sheet(list);
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Factura NCF" + Select.mes +Select.ano+".xlsx")
    }

    const exportarExcelDGII = () => {
        let response = fetch(Api + "DGII/ExportarExcel" );
        if (response.ok) {
            let data = response.json()
            alert();

        }

     //let   response =  fetch(Api + "DGII/ExportarExcel", {
     //       method: 'POST',
     //       headers: {
     //           'Content-Type': 'application/json;charset=utf-8'
     //       },
     //       body: JSON.stringify(tabla)
     //   })
        Swal.fire(
            'Se genero el excel de validacion!',
            'Revisar su inidad C: carpeta DGII',
            'success'
        )
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'RNC',
            selector: row => row.rnc,
            sortable: true,
        },
        {
            name: 'Fecha ',
            selector: row => moment( row.fechaFactura).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Comercio ',
            selector: row => row.comercio,
            sortable: true,
        },
        {
            name: 'NCF ',
            selector: row => row.ncf,
            sortable: true,
        },
        {
            name: 'ITBS ',
            selector: row => row.montoItbs,
            sortable: true,
        },
        {
            name: 'Monto Total ',
            selector: row => row.montoTotal,
            sortable: true,
        },

        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingLeft: '5px',
                paddingRight: '5px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                paddingLeft: '5px',
                paddingRight: '5px',
            }
        },
        cells: {
            style: {
               marginRight: '2px',
                paddingLeft: '5px',
                paddingRight: '5px',
            }
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    
    tabla.creadoPor = JSON.parse(user).correo;
    let DGII = JSON.parse(user).dgii;

    const Exp606=()=> {
        let lyrics =
            "606|"+DGII+"|" + Select.ano + Select.mes + "|" + Listado.length+"\n" +
            Listado.map(x =>
                x.rnc + "|1|" + x.ncf + "||" + moment(x.fecha).format("YYYYMMDD") + "|" + moment(x.fecha).format("YYYYMMDD") +
                "|" + x.montoTotal + "|" + "|" + x.montoTotal + "|" + x.montoItbs + "||||" + x.montoItbs+"||||||||"+x.formaPago+"\n");

      //  var blob = new Blob([lyrics.replace(',','')], { type: "text/plain;charset=utf-8" });
        var blob = new Blob([lyrics.split(",").join('')], { type: "text/plain;charset=utf-8" });
        saveAs(blob, "DGII_F_606_WEB" + Select.ano + Select.mes + ".txt");
    }

    ///link
    const { search } = useLocation();      // ?RncEmisor=...&RncComprador=133254239&...
    const [tabla1, setTabla1] = useState({ rncComprador: "" , ncf:""/* ...otros campos */ });


  

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Registros de NCF.
                </CardHeader>
                <CardBody>
                    <Row className="align-items-end">
                        <Col sm={2}>
                            <FormGroup>
                            <Button color="success" size="md"
                                onClick={() => nuevo()}
                                >Nuevo Registro</Button>
                                </FormGroup>
                        </Col>

                        <Col sm={2}>
                            <FormGroup>
                                <Label>Mes:</Label>

                                <Input className="form-control" bsSize="sm" type={"select"} onChange={handleChange1} name="mes" value={Select.mes} >
                                    <option value={0}>Todo el Año</option>
                                    <option value={1}>Enero</option>
                                    <option value={2}>Febrero </option>
                                    <option value={3}>Marzo</option>
                                    <option value={4}>Abril </option>
                                    <option value={5}>Mayo</option>
                                    <option value={6}>Junio </option>
                                    <option value={7}>Julio</option>
                                    <option value={8}>Agosto </option>
                                    <option value={9}>Septiembre</option>
                                    <option value={10}>Octubre </option>
                                    <option value={11}>Noviembre</option>
                                    <option value={12}>Diciembre </option>
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col sm={2}>
                            <FormGroup>
                                <Label>Año:</Label>
                                <Input name="ano" id="ano" onChange={handleChange1} value={Select.ano}></Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <button size="sm" color="primary" class="btn-search" block onClick={() => setImpresion(true)}>
                                    <i class="fas fa-print"></i> Imprimir
                                </button>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                              
                                <Button hidden={ true} color="primery" size="sm" block onClick={exportarExcelDGII}>
                                    <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar Excel DGII
                                </Button>
                                <Button color="primery" size="sm" block onClick={exportarExcel}>
                                    <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar
                                </Button>
                                <Button color="primery" size="sm" block onClick={Exp606}>
                                    <i className="fa fa-file" aria-hidden="true"></i> TXT
                                </Button>
                            </FormGroup>
                        </Col>

                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Registro de Factura NCF
                </ModalHeader>
                <ModalBody>

                  

                   

                    <Row>
                        {/*<QRScanner onResult={handleQrResult} />*/}
                        <Col sm={6}>
                            <FormGroup>
                                <Label>RNC </Label>
                                <i hidden={tabla.rnc.length == 11 || tabla.rnc.length == 9} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                <i hidden={tabla.rnc.length != 11 || tabla.rnc.length != 9} style={{ color: "green" }} className="fas fa-check"></i>
                                <Input disabled={Visualizar} bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Comercio</Label>
                                <Input disabled={Visualizar}  bsSize="sm" name="comercio" onChange={handleChange} value={tabla.comercio} />

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                       <Col sm={6}>
                            <FormGroup>
                                <Label>Fecha de la Factura</Label>
                                <Input disabled={Visualizar} bsSize="sm" type="date" name="fechaFactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>NCF </Label>
                                <i hidden={tabla.ncf.length == 11 || tabla.ncf.length == 13} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                <i hidden={tabla.ncf.length != 11 || tabla.ncf.length != 13} style={{ color: "green" }} className="fas fa-check"></i>
                                <Input disabled={Visualizar} bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                            </FormGroup>
                        </Col>
                       
                    </Row>
                    <Row>
                     <Col sm={6}>
                            <FormGroup>
                                <Label>Monto ITBS</Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoItbs" onChange={handleChange} value={tabla.montoItbs} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Monto Total Factura </Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoTotal" onChange={handleChange} value={tabla.montoTotal} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Forma de Pago</Label>
                                <Input bsSize="sm" type={"select"} className="form-control" onChange={handleChange} name="formaPago" value={tabla.formaPago} >
                                    <option value={"01"}>Efectivo</option>
                                    <option value={"02"}>Cheque/Tran</option>
                                    <option value={"03"}>Tarjeta</option>
                                    <option value={"Otro"}>Otro</option>
                                    </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Comentario</Label>
                                <Input disabled={Visualizar} type="textarea" bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />

                            </FormGroup>
                        </Col>
                      </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {<iframe
                                src={"/Informes/DGII/ReporteFacturaNCF.html?API=" + R_API}
                                title="Contenido HTML"
                                style={{ width: '100%', height: '800px', border: 'none' }}

                            />}


                            <Button size="sm" color="danger"
                                onClick={() => setImpresion(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>
        </>
    )

}
export default R_F_NCF;